module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ack-head"
  }, [_c('i', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("My wholehearted thanks goes to Amy Marson and the entire team at C&T Publishing—my editors Michele Fry, Joanna Burgarino, Alison Schmidt, Katie Van Amburg, and Nan Powell; my book designer Katie McIntosh and cover designer Kristy Zacharias; the photography team of Nissa Brehmer, Diane Pedersen, and Mary Peyton Peppo; production coordinator Freesia Pearson Blizard; illustrator Jenny Davis; and of course Roxane Cerda and Gailen Runge.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Also thanks to the wonderful companies that manufacture the fabrics that I used to create the pieces for this book: Art Gallery Fabrics, Blend Fabrics, Riley Blake Fabrics, and Robert Kaufman Fabrics. The talented designers whose fabrics I was fortunate enough to play with are listed in Resources.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("A heartfelt thanks goes to Aurifil and the Warm Company. Aurifil threads come in a wonderful array of colors and are such a pleasure with which to sew! All the quilts feature Warm & White batting—my favorite!")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("And last but not least I’d like to thank BERNINA. It is a pleasure to sew each and every stitch using your wonderful machines. Thanks for your support.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17e83963","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_ack.vue
// module id = 66
// module chunks = 0